import React, { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { Spin, message } from 'antd'
import api from '../../services/api'

export default function WecomCallback() {
  const [params] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    const code = params.get('code')
    if (!code) {
      message.error('授权失败，未获取到code')
      navigate('/login')
      return
    }
    api.get('/auth/wecom/callback', { params: { code } })
      .then(res => {
        localStorage.setItem('crm_token', res.token)
        localStorage.setItem('crm_user', JSON.stringify(res.user))
        window.location.href = '/'
      })
      .catch(err => {
        message.error(err.error || '登录失败')
        navigate('/login')
      })
  }, [])

  return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Spin size="large" tip="企业微信登录中..." /></div>
}
